import { useState, useEffect } from "react";
import anime from "animejs";
import "../App.css"

export default function Grid() {
    const [state, setState] = useState({
        rows: 0,
        columns: 0,
        total: 1
    })

    const gridSize = () => {
        let columns, rows;

        columns = Math.floor(document.documentElement.clientWidth / 100);
        rows = Math.floor(document.documentElement.clientHeight / 100);

        setState({
            rows: rows,
            columns: columns,
            total: rows * columns
        })

        document.body.style.setProperty("--rows", state.rows);
        document.body.style.setProperty("--columns", state.columns);
    
        
    
        anime({
          targets: ".tile",
          duration: 0,
          easing: "linear",
        });
    }

    useEffect(() => {
        let columns, rows;
        columns = Math.floor(document.documentElement.clientWidth / 100);
        rows = Math.floor(document.documentElement.clientHeight / 100);
    
        setState((prevState) => ({
          ...prevState,
          rows: rows,
          columns: columns,
          total: rows * columns,
        }));
    
        document.body.style.setProperty("--rows", rows);
        document.body.style.setProperty("--columns", columns);
        
      }, [state]);
    
      window.onresize = gridSize;

      const handleStagger = (i) => {
        //Find the id of tile clicked
        const el = i.target.id;
    
        anime({
          targets: ".tile",
        //   backgroundColor: "red",
          scale: [
            {value: .1, easing: 'easeOutSine', duration: 500},
            {value: 1, easing: 'easeInOutQuad', duration: 1200}
          ],
          delay: anime.stagger(50, { grid: [state.columns, state.rows], from: el }),
        });
      };

    //   anime({
    //     targets: ".tile",
    //     translateX: anime.stagger(10, {grid: [state.columns, state.rows], from: 'center', axis: 'x'}),
    //     translateY: anime.stagger(10, {grid: [state.columns, state.rows], from: 'center', axis: 'y'}),
    //     rotateZ: anime.stagger([0, 90], {grid: [state.columns, state.rows], from: 'center', axis: 'x'}),
    //     delay: anime.stagger(100, { grid: [state.columns, state.rows], from: el }),
    //     easing: 'easeInOutQuad'
    //   });
    // }

      // delay: anime.stagger(50, { grid: [state.columns, state.rows], from: el }),

      return (
        <div>
          <div id="tiles">
            {[...Array(state.total)].map((tile, i) => (
              <div
                className="tile"
                key={i}
                id={i}
                onClick={(i) => handleStagger(i)}
              />
            ))}

          </div>
        </div>
      );

}